// Fixed created.ai watermark; a server-started media step, never a public composer.
import { VideoWatermarkQuote, VideoWatermarkRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.watermark"> = {
  type: "video.watermark",
  label: "Watermark",
  source: "form",
  pair: "video.watermark",
  fields: () => ({}),
  request: VideoWatermarkRequest,
  quote: VideoWatermarkQuote,
};
